import React, { useEffect, useRef, useState } from "react";
import { H3, LI } from "../../../../AbstractElements";
import { BookMarkContainerProps } from "../../../../Types/Layout.type";
import SvgIcon from "../../../../Utils/CommonComponents/CommonSvgIcons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../ReduxToolkit/Store";
import { setBookMarkClass } from "../../../../ReduxToolkit/Reducers/BookmarkReducer";
import { Href } from "../../../../Utils/Constants";
import { Link } from "react-router-dom";
import FavouriteListTable from "./FavouriteList";

export default function BookmarkContainer({
  handleBookmark,
  bookmarkList,
  bookmarkItems,
  handleSearch,
}: BookMarkContainerProps) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const { bookMarkClass } = useSelector((state: RootState) => state.bookmark);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const toggle = (e?: React.MouseEvent) => {
    e?.preventDefault();
    setDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    if (!dropdownOpen) return;
    const onPointerDown = (ev: MouseEvent | PointerEvent) => {
      const el = dropdownRef.current;
      if (!el) return;

      const target = ev.target as Node;
      if (!el.contains(target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("pointerdown", onPointerDown);
    return () => document.removeEventListener("pointerdown", onPointerDown);
  }, [dropdownOpen]);

  const backToBookmark = () => {
    dispatch(setBookMarkClass(!bookMarkClass));
  };

  return (
    <LI className="custom-dropdown">
      <Link to={Href} onClick={toggle}>
        <SvgIcon iconId="bookmark" />
      </Link>

      <div
        ref={dropdownRef}
        className={`custom-menu bookmark-dropdown py-0 overflow-hidden ${
          dropdownOpen ? "show" : ""
            }`}
        >
        <div className="flip-card">
          <div className={`flip-card-inner ${bookMarkClass ? "flipped" : ""}`}>
            <div className="front">
              <div className="px-3 pb-3">
                <div className="mt-2 mb-2">
                  <H3>Preferiti</H3>
                </div>
                <FavouriteListTable open={dropdownOpen} />
              </div>
            </div>

            {/* back commentato come avevi */}
          </div>
        </div>
      </div>
    </LI>
  );
}
